// extracted by mini-css-extract-plugin
module.exports = {"container":"PageFive_container__IoO0h","main-container":"PageFive_main-container__ULxpU","board-container":"PageFive_board-container__2f82R"};